import { render, staticRenderFns } from "./IconCourseConiclex.vue?vue&type=template&id=42bd5f4d"
import script from "./IconCourseConiclex.vue?vue&type=script&lang=js"
export * from "./IconCourseConiclex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports